import { render, staticRenderFns } from "./Hekim.vue?vue&type=template&id=27bd9a05&scoped=true&"
import script from "./Hekim.vue?vue&type=script&lang=js&"
export * from "./Hekim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bd9a05",
  null
  
)

export default component.exports